import Proxy from './Proxy';

class ReportProxy extends Proxy {
  constructor(parameters = {}) {
    super('report/api/v1/', parameters);
  }

  organisationWiseAdminConsoleData(param) {
    return this.submit(
      'get',
      `${this.endpoint}scheduled-reports/getAll/orgDetails`,
    );
  }
  getPubsubDetails(organisationId) {
    return this.submit('get', `${this.endpoint}device/getPubsubDetails/fromOrg?organisationId=${organisationId}`)
  }
}

export default ReportProxy;
